import React from "react";
import clsx from "clsx";

type Tone = "dark" | "light";

export interface DisclaimerMiniProps {
  tone?: Tone; // affects text color
  align?: "left" | "center";
  fixedOnDesktop?: boolean; // md+: fixed bottom; mobile: static in-flow
  className?: string;
  /**
   * Outer horizontal padding (mirrors PageContainer). E.g. "px-6 md:px-8".
   */
  containerPadding?: string;
  /**
   * Parent max width (mirrors PageContainer max). E.g. "max-w-[1280px]".
   */
  parentMaxWidthClassName?: string;
  /**
   * Inner max width to match the quiz card width. E.g. "max-w-2xl".
   */
  innerMaxWidthClassName?: string;
  extraBottomPaddingPx?: number;
}

export const DisclaimerMini: React.FC<DisclaimerMiniProps> = ({
  tone = "dark",
  align = "left",
  fixedOnDesktop = true,
  className,
  containerPadding = "px-4 md:px-6",
  parentMaxWidthClassName = "max-w-[1280px]",
  innerMaxWidthClassName = "max-w-2xl",
  extraBottomPaddingPx = 0,
}) => {
  const year = new Date().getFullYear();

  const textTone = tone === "dark" ? "text-slate-300" : "text-slate-600";
  const alignClass = align === "left" ? "text-left" : "text-center";
  const bottomPad = extraBottomPaddingPx > 0
    ? `calc(env(safe-area-inset-bottom) + ${extraBottomPaddingPx}px)`
    : "env(safe-area-inset-bottom)";

  return (
    <div
      className={clsx(
        fixedOnDesktop && "md:fixed md:left-0 md:right-0 md:bottom-8 md:z-50",
        "block",
        className
      )}
      style={{ paddingBottom: bottomPad }}
    >
      {/* Mirror PageContainer structure to align with quiz card */}
      <div className={clsx("w-full", containerPadding)}> 
        <div className={clsx("w-full mr-auto", parentMaxWidthClassName)}> 
          <div className={clsx("w-full mx-auto", innerMaxWidthClassName)}> 
            <div className={clsx("text-[12px] leading-5 font-barlow space-y-3", textTone, alignClass)}>
              <p>
                © {year} Unis Lumen. All rights reserved. WealthKit™, RiskIQ Score™, PortfolioIQ™ and AltsIQ™ are trademarks of Unis Lumen.
              </p>
              <p>
                Insights from WealthKit™, RiskIQ Score™, PortfolioIQ™ and AltsIQ™ are educational only and do not constitute personalized financial, investment, tax or legal advice. Always consult a qualified professional before making investment decisions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerMini;
